const DetailPanel = () => {
  return <p>vendor detail panel </p>
}

export default DetailPanel
